import { SyntheticEvent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { getMountPath } from 'utils/generic/route-manipulation';
import { isMobile } from 'utils/is-mobile';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import { setScrollToCompetitionId } from 'store/actions';

type TCompetitionClickHandler = {
  ({
    sportAlias,
    regionAlias,
    compId,
    e,
    returnURLOnly,
    skipCategory,
    forcePushUrl
  }: {
    sportAlias: string;
    regionAlias: string;
    compId: number;
    e?: SyntheticEvent;
    returnURLOnly?: boolean;
    skipCategory?: boolean;
    forcePushUrl?: boolean;
  }): string;
};

export const useCompetitionClick = (
  category?: string
): TCompetitionClickHandler => {
  const { path, params } = useSbRouteMatch();
  const dispatch = useDispatch();
  const history = useHistory();

  const competitionClickHandler: TCompetitionClickHandler = useCallback(
    ({
      sportAlias,
      regionAlias,
      compId,
      e,
      returnURLOnly,
      skipCategory,
      forcePushUrl
    }) => {
      if (
        SpringConfigs.MOCKED_DATA ||
        (String(compId) === params?.competition &&
          !returnURLOnly &&
          !forcePushUrl)
      ) {
        return '';
      }

      const newPath = `${getMountPath(path)}${
        category && !skipCategory ? `/${category}` : ''
      }/${sportAlias}/${regionAlias}/${compId}${history.location.search}`;

      if (returnURLOnly) {
        return newPath;
      }

      history.push(newPath);

      if (isMobile()) {
        dispatch(
          setScrollToCompetitionId({
            id: compId.toString(),
            top: e?.currentTarget.getBoundingClientRect().top || 0
          })
        );

        window.scrollTo(0, 0);
      }

      return '';
    },
    [path, category, params?.competition]
  );

  return competitionClickHandler;
};
